module.exports = __webpack_public_path__ + "img/project-innerpage-3.jpg?fd8bc3458a1dad7db6acbb51d9bd9802";